const ads = [
    {
        "id": "BATimes 1",
        "link": "http://www.batimes.com",
        "image": new URL("../assets/advertising/batimes.jpg", import.meta.url).toString()
    },
    {
        "id": "BPMN Poster 1",
        "link": "http://www.trisotech.com/infographics/bpmn-poster",
        "image": new URL("../assets/advertising/BPMN-Poster.png", import.meta.url).toString()
    },
    {
        "id": "CMMN Poster 1",
        "link": "http://www.trisotech.com/infographics/cmmn-poster",
        "image": new URL("../assets/advertising/CMMN-Poster.png", import.meta.url).toString()
    },
    {
        "id": "COVID 1",
        "link": "https://www.trisotech.com/Covid-19?utm_source=Micro-campaign&utm_medium=BPI&utm_campaign=COVID-19",
        "image": new URL("../assets/advertising/Social-Post-Covid19-BPI.png", import.meta.url).toString()
    },
    {
        "id": "COVID 2",
        "link": "https://www.trisotech.com/Covid-19?utm_source=Micro-campaign&utm_medium=BPI&utm_campaign=COVID-19",
        "image": new URL("../assets/advertising/Social-Post-Covid19-BPI-2.png", import.meta.url).toString()
    },
    {
        "id": "DES 1",
        "link": "http://www.trisotech.com/digital-enterprise-suite",
        "image": new URL("../assets/advertising/DES-–-1.jpg", import.meta.url).toString()
    },
    {
        "id": "DES 2",
        "link": "http://www.trisotech.com/digital-enterprise-suite",
        "image": new URL("../assets/advertising/DES-–-2.png", import.meta.url).toString()
    },
    {
        "id": "DES 3",
        "link": "http://www.trisotech.com/digital-enterprise-suite",
        "image": new URL("../assets/advertising/DES-–-3.png", import.meta.url).toString()
    },
    {
        "id": "MNS 1",
        "link": "https://methodandstyle.com/dmn-training/",
        "image": new URL("../assets/advertising/mns-1.jpg", import.meta.url).toString()
    },
    {
        "id": "MNS 2",
        "link": "https://methodandstyle.com/dmn-training/",
        "image": new URL("../assets/advertising/mns-2.jpg", import.meta.url).toString()
    },
    {
        "id": "MNS 3",
        "link": "https://methodandstyle.com/dmn-training/",
        "image": new URL("../assets/advertising/mns-3.jpg", import.meta.url).toString()
    },
    {
        "id": "DMN Poster 1",
        "link": "http://www.trisotech.com/infographics/dmn-poster",
        "image": new URL("../assets/advertising/DMN-Poster.png", import.meta.url).toString()
    },
    {
        "id": "DMN Quick Start",
        "link": "http://www.trisotech.com/dmnquickstart",
        "image": new URL("../assets/advertising/DMN-Quick-Start-V1.jpg", import.meta.url).toString()
    },
    {
        "id": "Quick Guide",
        "link": "http://www.bpmnquickguide.com/viewit.html",
        "image": new URL("../assets/advertising/bpmnquickguide.png", import.meta.url).toString()
    },
    {
        "id": "TEC Campus Program",
        "link": "https://campusstaging.technologyevaluation.com/",
        "image": new URL("../assets/advertising/tec-campus-program.png", import.meta.url).toString()
    },
    {
        "id": "BPI 10 Most",
        "link": "https://www.trisotech.com/trisotech-the-architect-of-agile-digital-enterprise/",
        "image": new URL("../assets/advertising/BPI-10most.jpg", import.meta.url).toString()
    },
    {
        "id": "Visio",
        "link": "http://www.trisotech.com/visio",
        "image": new URL("../assets/advertising/VisioStencils.png", import.meta.url).toString()
    }
];

const display_groups = [
    {
        // Top
        "id": 0,
        "ads": [
            // Top-specific ads
            { "adId": "DES 3", "weight": 10 },
            { "adId": "DMN Quick Start", "weight": 10 },
            { "adId": "BPI 10 Most", "weight": 10 },
            // Generic ads
            { "adId": "BPMN Poster 1", "weight": 5 },
            { "adId": "CMMN Poster 1", "weight": 5 },
            { "adId": "COVID 2", "weight": 5 },
            { "adId": "DMN Poster 1", "weight": 5 },
            { "adId": "Quick Guide", "weight": 5 }
        ]
    },
    {
        // Middle
        "id": 1,
        "ads": [
            // Middle-specific ads
            { "adId": "BATimes 1", "weight": 10 },
            { "adId": "COVID 1", "weight": 10 },
            { "adId": "MNS 1", "weight": 10 },
            { "adId": "MNS 2", "weight": 10 },
            { "adId": "MNS 3", "weight": 10 },
            { "adId": "TEC Campus Program", "weight": 10 },
            // Generic ads
            { "adId": "BPMN Poster 1", "weight": 5 },
            { "adId": "CMMN Poster 1", "weight": 5 },
            { "adId": "COVID 2", "weight": 5 },
            { "adId": "DMN Poster 1", "weight": 5 },
            { "adId": "Quick Guide", "weight": 5 }
        ]
    },
    {
        // Bottom
        "id": 2,
        "ads": [
            // Bottom-specific ads
            { "adId": "COVID 1", "weight": 10 },
            { "adId": "DES 1", "weight": 10 },
            { "adId": "DES 2", "weight": 10 },
            { "adId": "MNS 3", "weight": 10 },
            { "adId": "Visio", "weight": 10 },
            // Generic ads
            { "adId": "BPMN Poster 1", "weight": 5 },
            { "adId": "CMMN Poster 1", "weight": 5 },
            { "adId": "COVID 2", "weight": 5 },
            { "adId": "DMN Poster 1", "weight": 5 },
            { "adId": "Quick Guide", "weight": 5 }
        ]
    }
];

const MAX_RETRY = 3;

class AdManager {
    displayAds() {
        let chosenAds = [];
        for (let groupKey in display_groups) {
            let group = display_groups[groupKey];

            let groupId = group.id;
            let groupWeight = 0;
            group.ads.map((ad) => groupWeight += ad.weight);

            let retry_count = 0;
            while (retry_count < MAX_RETRY) {

                let adWeightIndex = Math.floor(Math.random() * groupWeight);
                let weightCounter = 0;
                let chosenAdId;
                for (let adId in group.ads) {
                    weightCounter += group.ads[adId].weight;
                    if (weightCounter >= adWeightIndex) {
                        chosenAdId = group.ads[adId].adId;
                        break;
                    }
                }
                if (chosenAds.includes(chosenAdId)) {
                    retry_count++;
                } else {
                    chosenAds[groupId] = chosenAdId;
                    break;
                }
            }
        }

        let adZoneList = document.querySelectorAll("div [class=ad-display-group]");
        for (let adZoneKey in adZoneList) {
            let adNode = adZoneList[adZoneKey];
            if (typeof adNode === "object"){
                // data-display-group-id
                let groupId = adNode.dataset.displayGroupId;
                let adIdForGroup = chosenAds[groupId];
                let adForGroup = ads.find((adItem) => adItem.id === adIdForGroup);

                let adLink = adNode.querySelector("a");
                adLink.setAttribute("href", adForGroup.link);

                let adImg = adNode.querySelector("img");
                adImg.setAttribute("src", adForGroup.image);
            }
        }
    }
}

export default new AdManager();
